module.exports = registerEndpoints;

var _require = require("deprecation"),
    Deprecation = _require.Deprecation;

function registerEndpoints(octokit, routes) {
  Object.keys(routes).forEach(function (namespaceName) {
    if (!octokit[namespaceName]) {
      octokit[namespaceName] = {};
    }

    Object.keys(routes[namespaceName]).forEach(function (apiName) {
      var apiOptions = routes[namespaceName][apiName];
      var endpointDefaults = ["method", "url", "headers"].reduce(function (map, key) {
        if (typeof apiOptions[key] !== "undefined") {
          map[key] = apiOptions[key];
        }

        return map;
      }, {});
      endpointDefaults.request = {
        validate: apiOptions.params
      };
      var request = octokit.request.defaults(endpointDefaults); // patch request & endpoint methods to support deprecated parameters.
      // Not the most elegant solution, but we don’t want to move deprecation
      // logic into octokit/endpoint.js as it’s out of scope

      var hasDeprecatedParam = Object.keys(apiOptions.params || {}).find(function (key) {
        return apiOptions.params[key].deprecated;
      });

      if (hasDeprecatedParam) {
        var patch = patchForDeprecation.bind(null, octokit, apiOptions);
        request = patch(octokit.request.defaults(endpointDefaults), ".".concat(namespaceName, ".").concat(apiName, "()"));
        request.endpoint = patch(request.endpoint, ".".concat(namespaceName, ".").concat(apiName, ".endpoint()"));
        request.endpoint.merge = patch(request.endpoint.merge, ".".concat(namespaceName, ".").concat(apiName, ".endpoint.merge()"));
      }

      if (apiOptions.deprecated) {
        octokit[namespaceName][apiName] = function deprecatedEndpointMethod() {
          octokit.log.warn(new Deprecation("[@octokit/rest] ".concat(apiOptions.deprecated)));
          octokit[namespaceName][apiName] = request;
          return request.apply(null, arguments);
        };

        return;
      }

      octokit[namespaceName][apiName] = request;
    });
  });
}

function patchForDeprecation(octokit, apiOptions, method, methodName) {
  var patchedMethod = function patchedMethod(options) {
    options = Object.assign({}, options);
    Object.keys(options).forEach(function (key) {
      if (apiOptions.params[key] && apiOptions.params[key].deprecated) {
        var aliasKey = apiOptions.params[key].alias;
        octokit.log.warn(new Deprecation("[@octokit/rest] \"".concat(key, "\" parameter is deprecated for \"").concat(methodName, "\". Use \"").concat(aliasKey, "\" instead")));

        if (!(aliasKey in options)) {
          options[aliasKey] = options[key];
        }

        delete options[key];
      }
    });
    return method(options);
  };

  Object.keys(method).forEach(function (key) {
    patchedMethod[key] = method[key];
  });
  return patchedMethod;
}